import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutExchangeRateQuickInfo extends Layout {
    sourceCurrencyConversions: DataSource;
    tableExchangeRates: Table;
}
